var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookMark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3434_857)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3434_857",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0.399902,
    width: 16,
    height: 25,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 0.399902,
    width: 16,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.7999C6 4.16338 6.25286 3.55293 6.70294 3.10285C7.15303 2.65276 7.76348 2.3999 8.4 2.3999H15.6C16.2365 2.3999 16.847 2.65276 17.2971 3.10285C17.7471 3.55293 18 4.16338 18 4.7999V21.5999L12 18.5999L6 21.5999V4.7999Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 2.3999V0.399902V2.3999ZM18 21.5999L17.1056 23.3888L20 24.836V21.5999H18ZM12 18.5999L12.8944 16.811L12 16.3638L11.1056 16.811L12 18.5999ZM6 21.5999H4V24.836L6.89443 23.3888L6 21.5999ZM8 4.7999C8 4.69382 8.04214 4.59207 8.11716 4.51706L5.28873 1.68863C4.46357 2.51379 4 3.63295 4 4.7999H8ZM8.11716 4.51706C8.19217 4.44205 8.29391 4.3999 8.4 4.3999V0.399902C7.23305 0.399902 6.11389 0.863472 5.28873 1.68863L8.11716 4.51706ZM8.4 4.3999H15.6V0.399902H8.4V4.3999ZM15.6 4.3999C15.7061 4.3999 15.8078 4.44204 15.8828 4.51706L18.7113 1.68863C17.8861 0.863472 16.767 0.399902 15.6 0.399902V4.3999ZM15.8828 4.51706C15.9579 4.59207 16 4.69382 16 4.7999H20C20 3.63295 19.5364 2.51379 18.7113 1.68863L15.8828 4.51706ZM16 4.7999V21.5999H20V4.7999H16ZM18.8944 19.811L12.8944 16.811L11.1056 20.3888L17.1056 23.3888L18.8944 19.811ZM11.1056 16.811L5.10557 19.811L6.89443 23.3888L12.8944 20.3888L11.1056 16.811ZM8 21.5999V4.7999H4V21.5999H8Z",
    fill: "#1890FF",
    mask: "url(#path-1-outside-1_3434_857)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3434_857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookMark2);
export default __webpack_public_path__ + "static/media/book_mark_2.9b9c0ce5cb6a4d51c3e5d5e45d54db80.svg";
export { ForwardRef as ReactComponent };